import { GiftIcon, RocketIcon, ShieldCheckIcon, SparklesIcon, ZapIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { BenefitItem } from './benefit-item.atom'

interface ProBenefitItemProps {
  text: string
}

const ProBenefitItem: React.FC<ProBenefitItemProps> = ({ text }): ReactNode => (
  <div className="flex items-center gap-2">
    <ZapIcon className="size-4 text-muted-foreground" />
    <span className="text-sm text-muted-foreground">{text}</span>
  </div>
)

export const AddPaymentMethodImmediateBenefits: React.FC = (): ReactNode => (
  <div className="flex flex-col gap-4">
    <BenefitItem
      icon={GiftIcon}
      title="Get $5 free credits"
      description="Instantly added to your balance when you add a card"
    />
    <BenefitItem
      icon={SparklesIcon}
      title="Unlock advanced SAAGA agent"
      description="Access our AI agent with built-in tools created by SAAGA"
    />
    <BenefitItem
      icon={ShieldCheckIcon}
      title="Demo mode - no charges"
      description="We won't charge your card unless you upgrade to Pro"
    />
  </div>
)

export const AddPaymentMethodProBenefits: React.FC = (): ReactNode => (
  <div className="flex flex-col gap-3">
    <div className="flex items-center gap-2">
      <RocketIcon className="size-5 text-muted-foreground" />
      <span className="font-medium text-muted-foreground">Upgrade to Pro later for</span>
    </div>
    <div className="flex flex-col gap-2 pl-7">
      <ProBenefitItem text="Access to advanced agents" />
      <ProBenefitItem text="Full marketplace access" />
      <ProBenefitItem text="Higher usage limits" />
      <ProBenefitItem text="Priority support" />
    </div>
  </div>
)
